import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

export const UpdateMetrics = (params: IParams) =>
  API.gatewayPost(`/${C300}/metrics/update/`, params);
